/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_IncludeInputs */

const en_us2_exercise_include = /** @type {(inputs: Exercise_IncludeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggest again`)
};

const pt_br2_exercise_include = /** @type {(inputs: Exercise_IncludeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltar a sugerir`)
};

const es_419_exercise_include = /** @type {(inputs: Exercise_IncludeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volver a sugerir`)
};

const pt_pt2_exercise_include = /** @type {(inputs: Exercise_IncludeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltar a sugerir`)
};

const fr_fr2_exercise_include = /** @type {(inputs: Exercise_IncludeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggérer à nouveau`)
};

const de_de2_exercise_include = /** @type {(inputs: Exercise_IncludeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wieder vorschlagen`)
};

const it_it2_exercise_include = /** @type {(inputs: Exercise_IncludeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggerisci di nuovo`)
};

/**
* | output |
* | --- |
* | "Suggest again" |
*
* @param {Exercise_IncludeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_include = /** @type {((inputs?: Exercise_IncludeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_IncludeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_include(inputs)
	if (locale === "es-419") return es_419_exercise_include(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_include(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_include(inputs)
	if (locale === "de-DE") return de_de2_exercise_include(inputs)
	if (locale === "it-IT") return it_it2_exercise_include(inputs)
	return en_us2_exercise_include(inputs)
});
export { exercise_include as "exercise.include" }